module.exports = __webpack_public_path__ + "c8232608e1837043c18f8e31d057501c.svg";